import createLucideIcon from '../createLucideIcon';

const PlusCircle = createLucideIcon('PlusCircleIcon', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['line', { x1: '12', y1: '8', x2: '12', y2: '16', key: '55jlg' }],
  ['line', { x1: '8', y1: '12', x2: '16', y2: '12', key: '1myapg' }],
]);

export default PlusCircle;
